// extracted by mini-css-extract-plugin
export default {"sliderContainer":"Slider_sliderContainer__A1h2U","slider":"Slider_slider__BYIJj"};